module.exports = __webpack_public_path__ + "static/praxis-143cbe448e63dbfc8c80e26803bb483f.jpg";